"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO = exports.PHONE = exports.NEW_PATIENT = exports.IN_PERSON = exports.ESTABLISHED_PATIENT = exports.ALL = void 0;
const NEW_PATIENT = exports.NEW_PATIENT = 'new';
const ESTABLISHED_PATIENT = exports.ESTABLISHED_PATIENT = 'established';
const PHONE = exports.PHONE = 'phone';
const VIDEO = exports.VIDEO = 'video';
const IN_PERSON = exports.IN_PERSON = 'in_person';
const ALL = exports.ALL = 'all';